import React from "react";
import { Box, Typography } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const FormCollectionDatePicker = ({
  label,
  value,
  onChange,
  labelColor = "var(--app-text-muted)",
  errors,
  required = false,
  disabled = false,
}) => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: labelColor,
          mb: "6px",
          fontFamily: "Figtree",
        }}
      >
        {label}
        {required && <span style={{ color: "#d32f2f" }}> *</span>}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          format="dd-MM-yyyy"
          value={value || null} //  pass Date object directly
          onChange={(newValue) => {
            onChange(newValue); //  store Date object
          }}
          disabled={disabled}
          maxDate={new Date()}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "filled",
              hiddenLabel: true,
              placeholder: "DD-MM-YYYY",
              error: !!(typeof errors === "string" || errors?.message),
              helperText:
                typeof errors === "string"
                  ? errors
                  : errors?.message || "",
              InputProps: {
                disableUnderline: true,
                sx: {
                  height: "48px",
                  borderRadius: "8px",
                  border: "1px solid var(--app-border)",
                  px: "12px",
                  fontFamily: "Figtree",
                  color: disabled ? "var(--app-text-muted)" : "var(--app-text)",
                  cursor: disabled ? "not-allowed" : "pointer",

                  "& input": {
                    cursor: disabled ? "not-allowed" : "pointer",
                  },
                },
              },
              sx: {
                cursor: disabled ? "not-allowed" : "pointer",

                "& .MuiPickersFilledInput-root": {
                  backgroundColor: disabled
                    ? "var(--app-surface) !important"
                    : "var(--app-surface) !important",
                  borderRadius: "8px",
                },

                "& .MuiPickersFilledInput-root:hover": {
                  backgroundColor: disabled
                    ? "var(--app-surface) !important"
                    : "var(--app-surface) !important",
                },

                "& .MuiPickersFilledInput-root.Mui-focused": {
                  backgroundColor: disabled
                    ? "var(--app-surface) !important"
                    : "var(--app-surface) !important",
                },

                "& .MuiPickersFilledInput-root.Mui-disabled": {
                  backgroundColor: "var(--app-surface-2) !important",
                },

                "& .MuiPickersFilledInput-input": {
                  padding: "14px 0",
                  cursor: disabled ? "not-allowed" : "pointer",
                },

                "& .MuiSvgIcon-root": {
                  color: disabled ? "var(--app-text-muted)" : "var(--app-text-muted)",
                  cursor: disabled ? "not-allowed" : "pointer",
                },

                "& .MuiPickersFilledInput-root:before, & .MuiPickersFilledInput-root:after":
                  {
                    display: "none",
                  },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default FormCollectionDatePicker;